module.exports = __webpack_public_path__ + "media/application/images/external-services/google-shopping-logo-d1436c84305cde6a8b090a8f8f2638b7.svg";